export default __webpack_public_path__ + "static/media/blueSearchIcon.1bd732b0.svg";